import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { COMPANY } from "@/data/site";

const Footer = () => (
  <footer className="bg-crest-navy text-white/80 mt-24" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 py-16 grid gap-12 md:grid-cols-12">
      <div className="md:col-span-5">
        <div className="inline-block bg-white rounded-md p-3">
          <img
            src={COMPANY.logoLight}
            alt={COMPANY.name}
            className="h-20 w-auto object-contain"
          />
        </div>
        <p className="mt-6 max-w-md text-sm leading-relaxed text-white/70 font-body">
          Cresttor Construction Ltd is a Liverpool-based construction firm built by a team with over <span className="text-crest-gold">30 years</span> of combined trade experience. We deliver render &amp; insulation, domestic extensions, commercial works and landscaping across the North West, North Wales and the Midlands.
        </p>
        <p className="mt-4 text-xs uppercase tracking-[0.18em] text-crest-gold">{COMPANY.tagline}</p>
      </div>

      <div className="md:col-span-3">
        <h4 className="font-display text-white text-sm uppercase tracking-[0.2em]">Navigate</h4>
        <hr className="gold-rule my-4" />
        <ul className="space-y-2 text-sm">
          <li><Link to="/" className="hover:text-crest-gold">Home</Link></li>
          <li><Link to="/about" className="hover:text-crest-gold">About Us</Link></li>
          <li><Link to="/services" className="hover:text-crest-gold">Services</Link></li>
          <li><Link to="/gallery" className="hover:text-crest-gold">Gallery</Link></li>
          <li><Link to="/contact" className="hover:text-crest-gold">Contact</Link></li>
          <li><Link to="/admin/login" className="text-white/40 hover:text-white text-xs mt-3 block" data-testid="footer-admin-link">Staff login →</Link></li>
        </ul>
      </div>

      <div className="md:col-span-4">
        <h4 className="font-display text-white text-sm uppercase tracking-[0.2em]">Contact</h4>
        <hr className="gold-rule my-4" />
        <ul className="space-y-3 text-sm font-body">
          <li className="flex items-start gap-3"><Phone className="h-4 w-4 mt-0.5 text-crest-gold" />
            <a href={COMPANY.phoneHref} className="hover:text-white" data-testid="footer-phone-link">{COMPANY.phone}</a>
          </li>
          <li className="flex items-start gap-3"><Mail className="h-4 w-4 mt-0.5 text-crest-gold" />
            <a href={COMPANY.emailHref} className="hover:text-white break-all" data-testid="footer-email-link">{COMPANY.email}</a>
          </li>
          <li className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-0.5 text-crest-gold" />
            <span>{COMPANY.area}</span>
          </li>
        </ul>
        <div className="mt-6 flex items-center gap-3">
          <a href={COMPANY.social.instagram} target="_blank" rel="noreferrer"
             className="h-9 w-9 grid place-items-center rounded-md border border-white/20 hover:border-crest-gold hover:text-crest-gold transition-colors"
             aria-label="Instagram" data-testid="footer-instagram">
            <Instagram className="h-4 w-4" />
          </a>
          <a href={COMPANY.social.facebook} target="_blank" rel="noreferrer"
             className="h-9 w-9 grid place-items-center rounded-md border border-white/20 hover:border-crest-gold hover:text-crest-gold transition-colors"
             aria-label="Facebook" data-testid="footer-facebook">
            <Facebook className="h-4 w-4" />
          </a>
          <a href={COMPANY.social.threads} target="_blank" rel="noreferrer"
             className="h-9 w-9 grid place-items-center rounded-md border border-white/20 hover:border-crest-gold hover:text-crest-gold transition-colors text-xs font-bold"
             aria-label="Threads" data-testid="footer-threads">@</a>
        </div>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 py-5 flex flex-col md:flex-row items-center justify-between text-xs text-white/50 gap-2">
        <span>© {new Date().getFullYear()} Cresttor Construction Ltd. All rights reserved.</span>
        <span>Registered in England &amp; Wales · {COMPANY.website}</span>
      </div>
    </div>
  </footer>
);

export default Footer;
